import { BillingPeriod } from './timePeriod'

export enum PRODUCT_TYPES {
    TRIAL = 'Trial',
    PAID = 'Paid',
}

export enum BILLING_TYPES {
    ANNUAL = 'UpfrontAnnual',
    MONTHLY = 'UpfrontMonthly',
    MONTHLYANNUAL = 'MonthlyAnnual',
}

export const BillingPeriodBillingTypesMapper: Record<BillingPeriod, BILLING_TYPES> = {
    [BillingPeriod.ANNUAL]: BILLING_TYPES.ANNUAL,
    [BillingPeriod.MONTHLY]: BILLING_TYPES.MONTHLY,
    [BillingPeriod.ANNUALBILLEDMONTHLY]: BILLING_TYPES.MONTHLYANNUAL,
}
